import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';

declare var gtag: any;

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {

  constructor(private _router: Router) {

    // do nothing if disabled
    if(!environment.googleAnalytics.enabled) {
        return 
    }
    // subscribe to events
    this._router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event) => {
        gtag('js', new Date());
        gtag('config', environment.googleAnalytics.trackingId, { 'page_path': (event as NavigationEnd).urlAfterRedirects });
    });
  }

  init() {

    // do nothing if disabled
    if(!environment.googleAnalytics.enabled) {
        return 
    }

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${environment.googleAnalytics.trackingId}`;
    document.getElementsByTagName('head')[0].appendChild(script);

    const gtagEl = document.createElement('script');
    const gtagBody = document.createTextNode(`
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());

      gtag('config', '${environment.googleAnalytics.trackingId}');
    `);
    gtagEl.appendChild(gtagBody);
    document.getElementsByTagName('head')[0].appendChild(gtagEl);
  }
}